import "./MyPcExperiencesRenderer.css";
import "../MyPcRenderer.css";

function MyPcExperiencesRenderer({ appRef }) {
	return (
		<div className="my-pc-renderer-container">
			<div className="my-pc-renderer-title-container">
				<a className="my-pc-renderer-title">experiences</a>
			</div>
			<div className="my-pc-renderer-container-2">
				<div className="my-pc-info-father-container">
					<div className="my-pc-info-container">
						<div className="my-pc-title3-container">
							<strong>REKOMENDO (REQUEST SERVICE PLATFORM)</strong>
							<br/>Feira de Santana, BA
							<br/><strong>Software Engineer</strong>
							<br/>05/2025 - 12/2025
							<br/><br/>
							● Responsible for updating app features and bug fixes for App, Backend and AdminPanel.
							<br/>● Created automations and webhooks for reducing repetitive activities.
							<br/>● Continued developing the activities listed below with more leadership responsibilities, ensuring code quality and reusability.
						</div>
						<div className="my-pc-thinkpad-container">
							<img src="icons/rekomendo.png" style={{ width: "260px", height: "160px" }}></img>
						</div>
					</div>
				</div>
			</div>
			<div className="my-pc-renderer-container-2">
				<div className="my-pc-info-father-container">
					<div className="my-pc-info-container">
						<div className="my-pc-title3-container">
							<strong>REKOMENDO (REQUEST SERVICE PLATFORM)</strong>
							<br/>Feira de Santana, BA
							<br/><strong>Junior Software Engineer</strong>
							<br/>12/2024 - 05/2025
							<br/><br/>
							● Created Mobile Apps for Android and IOS using Flutter with great practices of ui and ux principles.
							<br/>● Unit tests, Maintenance and creating new features on the backend produced in NodeJS.
							<br/>● Maintenance and creating new features on the AdminPanel produced in Angular.
							<br/>● Created Project Documentations. that reduced troubleshooting time by 40%
							<br/>● Experience with API Gateways and Payments services.
							<br/>● Provided services to REKOMENDO using agile methodologies (Scrum, Kanban, Jira).
						</div>
						<div className="my-pc-thinkpad-container">
							<img src="icons/rekomendo.png" style={{ width: "260px", height: "160px" }}></img>
						</div>
					</div>
				</div>
			</div>
			<div className="my-pc-renderer-container-2">
				<div className="my-pc-info-father-container">
					<div className="my-pc-info-container">
						<div className="my-pc-title3-container">
							<strong>ANDROID OPEN SOURCE PROJECT</strong>
							<br/>Germany
							<br/><strong>Android Developer | Builder</strong>
							<br/>12/2020 - 11/2024
							<br/><br/>
							● I contributed to the development for the Motorola devices, Motorola Moto G7 model and some changes and contributions in the project in general.
							<br/>● Kernel updates, General optimizations to the devices.
							<br/>● Corrections and updates to the device's components when a new Android update was released.
							<br/>● Daily Git/Github/Gitlab usage.
						</div>
						<div className="my-pc-thinkpad-container">
							<img src="icons/android.png" style={{ width: "260px", height: "160px" }}></img>
						</div>
					</div>
				</div>
			</div>
			<div className="my-pc-renderer-container-2">
				<div className="my-pc-info-father-container">
					<div className="my-pc-info-container">
						<div className="my-pc-title3-container">
							<strong>ANDROID OPEN SOURCE PROJECT</strong>
							<br/>Feira de Santana, BA
							<br/><strong>Android Tester</strong>
							<br/>12/2016 - 11/2020
							<br/><br/>
							● I contributed to the development with logs and feedback for developers
						</div>
						<div className="my-pc-thinkpad-container">
							<img src="icons/android.png" style={{ width: "260px", height: "160px" }}></img>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MyPcExperiencesRenderer;
